<script setup lang="ts">
import { ref } from 'vue';
import { inputProps, type InputInst } from 'naive-ui';

const props = defineProps(inputProps);

const inputRef = ref<InputInst | null>(null);

/**
 * A `<script setup>` component is closed, so a caller holding a ref to this
 * wrapper cannot reach the n-input inside it — and an input that appears in
 * place of a label (the analysis tab's rename) has to be focused the moment it
 * mounts. Forwarded rather than re-implemented, so this stays a 1:1 wrapper.
 */
defineExpose({
  focus: (): void => inputRef.value?.focus(),
  blur: (): void => inputRef.value?.blur(),
  select: (): void => inputRef.value?.select(),
});
</script>

<template>
  <n-input ref="inputRef" v-bind="props">
    <template v-if="$slots.prefix" #prefix>
      <slot name="prefix" />
    </template>
    <template v-if="$slots.suffix" #suffix>
      <slot name="suffix" />
    </template>
  </n-input>
</template>
